// extracted by mini-css-extract-plugin
var _1 = "EntityActionTypeSelect-moduleselectWrapper__jqhe0";
export { _1 as "selectWrapper" }
